<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Expert</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/experts" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateExpert" v-if="expert">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-4 col-xs-12">
                                <fg-input type="text"
                                          v-model="expert.name"
                                          label="Name"
                                          placeholder="Enter Name"
                                          v-validate="rules.name"
                                          data-vv-name="name"
                                          cus-name="name"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <fg-input type="text"
                                          v-model="expert.experties"
                                          label="Experties"
                                          placeholder="Enter Experties"
                                          v-validate="rules.experties"
                                          data-vv-name="experties"
                                          cus-name="experties"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <fg-input type="email"
                                          v-model="expert.email"
                                          label="E-mail"
                                          placeholder="Enter E-mail"
                                          v-validate="rules.email"
                                          data-vv-name="email"
                                          cus-name="email"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-4 col-xs-12">
                                <fg-input type="tel" maxlength="10"
                                          v-model="expert.phone"
                                          label="phone"
                                          placeholder="Enter Phone"
                                          v-validate="rules.phone"
                                          data-vv-name="phone"
                                          cus-name="phone"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-4" v-if="status.length">
                                <fg-select
                                        v-model="expert.active"
                                        label="Status"
                                        v-validate="rules.active"
                                        data-vv-name="status"
                                        cus-name="status"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="status"
                                        selectedKey="active"
                                        >
                                </fg-select>
                            </div>
                            <div class="col-md-4 col-xs-12" v-if="interests.length">
                              <fg-select
                                v-model="expert.interestId"
                                label="Interest"
                                v-validate="rules.interestId"
                                data-vv-name="interest"
                                cus-name="interest"
                                :has-errors="errors"
                                :is-fields="fields"
                                :list="interests"
                                selectedKey="interestId"
                                showLabel="interest"
                              >
                              </fg-select>
                                <!--<fg-input type="text"
                                          v-model="expert.interestName"
                                          label="Interest Name"
                                          placeholder="Enter Interest Name"
                                          v-validate="rules.interestName"
                                          data-vv-name="interestName"
                                          cus-name="interestName"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>-->
                            </div>
                            <div class="col-md-12 col-xs-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="expert.biography"
                                        label="Biography"
                                        placeholder="Enter Biography"
                                        v-validate="rules.biography"
                                        data-vv-name="Biography"
                                        cus-name="Biography"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                            <div class="col-md-12 col-xs-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="expert.areasofexpertise"
                                        label="Areas Of Expertise"
                                        placeholder="Enter Areas Of Expertise"
                                        v-validate="rules.areasofexpertise"
                                        data-vv-name="Areas Of Expertise"
                                        cus-name="Areas Of Expertise"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                            <div class="col-md-6 col-xs-12">
                                <fg-image type="file"
                                          v-on:file="updateLargeImg"
                                          v-model="expert.large_image"
                                          label="Large Image"
                                          v-validate="rules.large_image"
                                          data-vv-name="large image"
                                          cus-name="large image"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-image>
                            </div>
                            <div class="col-md-6 col-xs-12">
                                <fg-image type="file"
                                          v-on:file="updateSmallImg"
                                          v-model="expert.small_image"
                                          label="Small Image"
                                          v-validate="rules.small_image"
                                          data-vv-name="small image"
                                          cus-name="small image"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-image>
                            </div>
                          <div class="col-12" v-if="corps.length">
                            <label>Select Exclusive Corporations</label>
                            <multiselect
                              v-model="expert.csvCorpIds"
                              placeholder="Associate child Corporations"
                              :multiple="true"
                              :taggable="true"
                              :options="corps.map(type => type.corporationId)"
                              :custom-label="opt => corps.find(x => x.corporationId == opt).name"
                              required>
                              >
                            </multiselect>
                            <!--                    <fg-select-->
                            <!--                      v-model="parentCorp.corporationId"-->
                            <!--                      label="Select Corporation"-->
                            <!--                      :list="corps"-->
                            <!--                      selectedKey="corporationId"-->
                            <!--                      v-validate="rules.corporationId"-->
                            <!--                      data-vv-name="Corproration"-->
                            <!--                      cus-name="Corporation"-->
                            <!--                      :has-errors="errors"-->
                            <!--                      :is-fields="fields">-->
                            <!--                    </fg-select>-->
                          </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Expert
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    export default {
        name: 'EditExpert',
        created (){
        this.fetchCorporations();
        if(this.$store.getters.interests.length) this.interests = this.$store.getters.interests;
        else this.fetchInterests();
        this.$store.dispatch('GETSELECTEDEXPERT', this.$route.params.id).then(() =>{
            this.expert = this.selectedExpert;
            if (this.expert.csvCorpIds) {
              this.expert.csvCorpIds = this.expert.csvCorpIds.split(',')
            }

//        this.startDate = new Date(this.expert.start_date).toISOString();
//        this.endDate = new Date(this.expert.end_date).toISOString();
        })
    },
    data () {
        let dateTime = new Date();
        return {
            corps: [],
            largeNewImage: [],
            smallNewImage: [],
            interests: [],
            status: [{name:'Select an option'}, {active:true, name:'Active'}, {active:false, name:'Inactive'}],
            expert: this.selectedExpert || {
                name: '',
                experties: '',
                email: '',
                phone: '',
                active: '',
                biography: '',
                areasofexpertise: '',
                small_image: '',
                large_image: '',
                interestId: ''
            },
            rules: {
                name: {required : true, min: 5},
                experties: {required : true, min : 3},
                email: {required : true, email: true},
                phone: {required : true, numeric: true},
                active: {required : true},
                biography: {required : true, min : 15},
                areasofexpertise: {required : true, min : 15},
                small_image: {required : true},
                large_image: {required : true},
                interestId: {required : true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        updateExpert () {
            this.$validator.validateAll().then((result) => {
                if(result){
                    this.$store.dispatch('TOGGLE_LOADING', true);
                    let count = 0;
                    if (this.expert.csvCorpIds) {
                      this.expert.csvCorpIds = this.expert.csvCorpIds.join(',')
                    } else {
                      this.expert.csvCorpIds = null
                    }
                    let updateExpert = () =>{
//                        this.$store.dispatch('UPDATE_EXPERT', this.expert)
                        this.$store.dispatch('UPDATE_EXPERT', {
                            expert: this.expert,
                            large_image: this.largeNewImage,
                            small_image: this.smallNewImage
                        })
                                .then((res) => {
                                    console.log("UPDATE_EXPERT res : ", res);
                                    this.showPopup('Success!', 'Expert is successfully updated', 'success', ()=> this.$router.push('/admin/experts'))

                                })
                                .catch(err => {
                                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                                    console.log("UPDATE_EXPERT API error : ", err);
                                })
                    }
                    updateExpert();
                    /*if(this.largeNewImage.length){
                        imageHelpers.upload({
                                    data: this.expert.large_image,
                                    file: this.largeNewImage[0],
                                },
                                (err, res) => {
                                    console.log("imageHelpers.upload err : ", err);
                                    console.log("imageHelpers.upload res : ", res);
                                    if(res){
                                        count++;
                                        this.expert.large_image = res.Location;
                                        if(count == 2 || !this.smallNewImage.length) updateExpert();
                                    }
                                }
                        );
                    }
                    if(this.smallNewImage.length){
                        imageHelpers.upload({
                                    data: this.expert.small_image,
                                    file: this.smallNewImage[0],
                                },
                                (err, res) => {
                                    console.log("imageHelpers.upload err : ", err);
                                    console.log("imageHelpers.upload res : ", res);
                                    if(res){
                                        count++;
                                        this.expert.small_image = res.Location;
                                        if(count == 2 || !this.largeNewImage.length) updateExpert();
                                    }
                                });
                    }
                    if(!this.smallNewImage.length && !this.largeNewImage.length) updateExpert();*/
                }
            })
        },
        updateLargeImg(data){
            this.expert.large_image = data.path;
            this.largeNewImage = data.value;
            console.log("updateLargeImg data : ", data);
        },
        updateSmallImg(data){
            this.expert.small_image = data.path;
            this.smallNewImage = data.value;
            console.log("updateSmallImg data : ", data);
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        },
        fetchInterests () {
            this.$store.dispatch('FETCH_INTERESTS')
                    .then((res) => {
//                        res.unshift({name: "Select an option"});
                this.interests = res;
                console.log("this.interests : ", this.interests);
            })
        .catch(err => {
                console.log("API error : ", err);
            })
        }
    },
    computed: {...mapGetters([
        'experts', `getExpert${11}`, 'selectedExpert'])
    }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Experts/EditExpert.vue